import type { UpdateQuizUserReq } from '@/api/gen/_model/updateQuizUserReq';

import {
  type CompanyEditFormData,
  type ProfileEditFormData,
  type StudentEditFormData,
  type TeacherEditFormData,
} from './schema';

/**
 * 프로필 수정 폼 데이터를 API 요청 형식으로 변환
 */
export const transformProfileFormToApiRequest = (
  formData: ProfileEditFormData,
  userType: string,
): UpdateQuizUserReq => {
  const baseRequest: UpdateQuizUserReq = {
    name: 'userName' in formData ? formData.userName : undefined,
    phoneNumber: 'phoneNumber' in formData ? formData.phoneNumber : undefined,
    marketingConsent: {
      email:
        'emailMarketingAgreement' in formData
          ? formData.emailMarketingAgreement
          : undefined,
      phone:
        'phoneMarketingAgreement' in formData
          ? formData.phoneMarketingAgreement
          : undefined,
    },
  };

  switch (userType) {
    case 'student': {
      const studentData = formData as StudentEditFormData;
      baseRequest.memberInfo = {
        studentInfo: {
          institution: studentData.schoolName,
          schoolTypeCode: studentData.schoolTypeCode,
          schoolGradeCode: studentData.schoolGradeCode,
          verifiedSchool:
            studentData.verifiedSchool &&
            studentData.verifiedSchool.standardCode
              ? { standardCode: studentData.verifiedSchool.standardCode }
              : undefined,
        },
      };
      break;
    }
    case 'teacher': {
      const teacherData = formData as TeacherEditFormData;
      baseRequest.memberInfo = {
        teacherInfo: {
          institution: teacherData.schoolName,
          schoolTypeCode: teacherData.schoolTypeCode,
          schoolGradeCode: teacherData.schoolGradeCode,
          verifiedSchool:
            teacherData.verifiedSchool &&
            teacherData.verifiedSchool.standardCode
              ? { standardCode: teacherData.verifiedSchool.standardCode }
              : undefined,
        },
      };
      break;
    }
    case 'company': {
      const companyData = formData as CompanyEditFormData;
      baseRequest.memberInfo = {
        companyInfo: {
          companyName: companyData.companyName,
          position: companyData.position,
        },
      };
      break;
    }
    default:
      baseRequest.memberInfo = {
        normalInfo: {},
      };
      break;
  }

  return baseRequest;
};
